import React from 'react';
import { CSVLink } from 'react-csv';
import Button from '@mui/material/Button';

const ExportPageAsCSV = ({
  fileName,
  data,
  startDate = 'N/A',
  endDate = 'N/A',
  hotelName = '',
}) => {
  const headers = [
    { label: 'Start Date', key: 'StartDate' },
    { label: 'End Date', key: 'EndDate' },
    { label: '', key: 'ErrorDate' },
  ];

  const csvData = [
    {
      StartDate: startDate,
      EndDate: endDate,
    },
    {},
    {
      StartDate: 'Error Date',
      EndDate: 'Reservation ID',
      ErrorDate: 'Error Message',
    },
    ...data.map((item) => ({
      StartDate: item?.Date || '',
      EndDate: item?.ReservationID || '',
      ErrorDate: item?.ErrorMessage || '',
    })),
  ];

  return (
    <div>
      <Button variant='outlined' size='large' className='me-4 customize-btn'>
        <CSVLink
          style={{ color: '#828282', textDecoration: 'none' }}
          filename={hotelName + ' ' + fileName}
          headers={headers || []}
          data={csvData || 'N/A'}
        >
          Export CSV
          <span>
            <img
              className='mb-1 ms-2'
              src={'./assets/icons/dashboard/export-icon.svg'}
              alt={'export'}
            />
          </span>
        </CSVLink>
      </Button>
    </div>
  );
};

export default ExportPageAsCSV;
